export enum ExternalFolderProviderTypes {
  SharepointSite = 'sharepoint-site'
}
